// Supports <br>, <br/>, <br />, and variants with attributes (e.g. <br class="x" />)
const BR_TAG_REGEX = /<br(?:\s[^>]*)?\s*\/?\s*>/gi

const HTML_ENTITY_REGEX = /&(?:nbsp|amp|lt|gt|quot|#39);/gi

const HTML_ENTITIES: Record<string, string> = {
  nbsp: '\u00A0',
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  '#39': "'",
}

const decodeHtmlEntities = (text: string): string =>
  text.replace(HTML_ENTITY_REGEX, (entity) => {
    const key = entity.slice(1, -1).toLowerCase()
    return HTML_ENTITIES[key] ?? entity
  })

export const formatDisplayText = (text: string): string => {
  if (!text) return text

  const decoded = decodeHtmlEntities(text)
  return decoded.replace(BR_TAG_REGEX, '\n')
}
